import {ASE_STATISTICS_PENDING} from '../../actions/ase/actionAseStatistics';
import {ASE_STATISTICS_SEND, ASE_STATISTICS_SEND_ERROR} from '../../constants/websocketCommands';

export const aseStatistics = (state = {
    correlationId: '',
    isLoading: false,
    data: [],
}, action) => {
    switch (action.type) {
        case ASE_STATISTICS_PENDING: {
            const {correlationId} = action.payload;
            return Object.assign({}, state, {
                isLoading: true, correlationId
            });
        }
        case ASE_STATISTICS_SEND: {
            const {correlationId, result: {data}} = action.payload;
            if (correlationId !== state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isLoading: false, correlationId, data
                });
            }
        }
        case ASE_STATISTICS_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId !== state.correlationId) {
                return state;
            } else {
                return Object.assign({}, state, {
                    isLoading: false, correlationId
                });
            }
        }
        default: {
            return state;
        }
    }
};
